import { render, staticRenderFns } from "./JsonEditDialog.vue?vue&type=template&id=7b5fef12&scoped=true"
import script from "./JsonEditDialog.vue?vue&type=script&lang=js"
export * from "./JsonEditDialog.vue?vue&type=script&lang=js"
import style0 from "./JsonEditDialog.vue?vue&type=style&index=0&id=7b5fef12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5fef12",
  null
  
)

export default component.exports